import './i18n';
import './index.css';
import React from 'react';
import { hydrate, render } from 'react-dom';
import {
    Container,
    createStyles,
    makeStyles,
    Paper,
    Tab,
    Tabs,
    Theme,
    ThemeProvider,
} from '@material-ui/core';
import { krajowaBazaTheme } from './config/themes';
import { HaperProvider, useQueryCollectionWithPagination } from 'haper-hooks';
import { haper } from './shared/haper';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Search } from './pages/Search/Search';
import { AvailableTabs } from './shared/models/AvailableTabs';
import { TabPanel } from './components/TabPanel/TabPanel';
import { Info } from './pages/Info/Info';
import { Rules } from './pages/Rules/Rules';
// import { ReportNewSubstance } from './pages/ReportNewSubstance/ReportNewSubstance';
import { useTranslation } from 'react-i18next';
// import {
//     FormDispatch,
//     formReducer,
//     initialFormState,
// } from './shared/store/formStore';
import { getDataLists, FetchedDataParams } from './config/endpoints';
import { QueryResult, QueryResultParams } from './shared/store/substancesStore';
import { Compound, Substance } from './shared/models/Substance';

const rootElement = document.getElementById('root');

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            margin: theme.spacing(5, 0),
        },
        paperContainer: {
            padding: theme.spacing(5),
        },
    }),
);

function a11yProps(index: AvailableTabs) {
    return {
        id: `searcher-tab-${index}`,
        'aria-controls': `searcher-tabpanel-${index}`,
    };
}

const SIZE = 25;

const App = () => {
    const classes = useStyles();
    const [t] = useTranslation();
    const [tab, setTab] = React.useState<AvailableTabs>(AvailableTabs.Search);
    const handleTabChange = (
        event: React.ChangeEvent<{}>,
        newValue: AvailableTabs,
    ) => {
        setTab(newValue);
    };
    // const [state, dispatch] = useReducer(formReducer, initialFormState);

    const queryResult = useQueryCollectionWithPagination<
        Substance | Compound,
        FetchedDataParams
    >(
        ({ pageSize, pageNumber, params }) => {
            return getDataLists(
                JSON.parse(
                    JSON.stringify({
                        ...params,
                        offset: (pageNumber - 1) * pageSize,
                        size: pageSize,
                    }),
                ),
            );
        },
        {
            pageSize: SIZE,
            pageNumber: 1,
            params: {
                searchBy: 'name',
            },
        },
    );

    return (
        // <React.StrictMode> //warning on Dialog
        <GoogleReCaptchaProvider
            reCaptchaKey={
                process.env.REACT_APP_SITEKEY || window.appConfig.APP_SITEKEY
            }
            language="pl-PL"
            scriptProps={{
                async: false, // optional, default to false,
                defer: false, // optional, default to false
                appendTo: 'head', // optional, default to "head", can be "head" or "body",
                nonce: undefined, // optional, default undefined
            }}
        >
            <HaperProvider haperInstance={haper}>
                <ThemeProvider theme={krajowaBazaTheme}>
                    <div className={classes.container}>
                        <Tabs
                            value={tab}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab
                                label={t('Search engine')}
                                {...a11yProps(AvailableTabs.Search)}
                            />
                            <Tab
                                label={t('About search engine')}
                                {...a11yProps(AvailableTabs.About)}
                            />
                            {/* <Tab
                                label={t('Report')}
                                {...a11yProps(AvailableTabs.Report)}
                            /> */}
                        </Tabs>
                        <QueryResult.Provider
                            value={
                                queryResult as QueryResultParams<
                                    Substance | Compound,
                                    FetchedDataParams
                                >
                            }
                        >
                            <TabPanel value={tab} index={AvailableTabs.Search}>
                                <Search onClick={setTab} />
                            </TabPanel>
                        </QueryResult.Provider>
                        <TabPanel value={tab} index={AvailableTabs.About}>
                            <Container maxWidth="md">
                                <Paper
                                    classes={{
                                        root: classes.paperContainer,
                                    }}
                                >
                                    <Info />
                                    <Rules onClick={setTab} />
                                </Paper>
                            </Container>
                        </TabPanel>
                        {/* <FormDispatch.Provider value={dispatch}>
                            <TabPanel value={tab} index={AvailableTabs.Report}>
                                <ReportNewSubstance
                                    onClick={setTab}
                                    state={state}
                                />
                            </TabPanel>
                        </FormDispatch.Provider> */}
                    </div>
                </ThemeProvider>
            </HaperProvider>
        </GoogleReCaptchaProvider>
        // </React.StrictMode>
    );
};

if (!rootElement) throw new Error('No Root element');

if (rootElement.hasChildNodes()) hydrate(<App />, rootElement);
else render(<App />, rootElement);
